<div *ngIf="canAccess">
  <h2 class="!mt-0" *ngIf="!isNewUser">
    {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.TITLE' | translate }}

    {{
      !createForm.get('name')?.value
        || createForm.get('name')?.value == ' '
        || createForm.get('name')?.value == undefined
      ? createForm.get('phone_number')?.value
      : createForm.get('name')?.value + ' ' + createForm.get('middle_name')?.value
    }}
  </h2>

  <h2 class="!mt-0" *ngIf="isNewUser">
    {{ 'COMPONENTS.PROFILE.MY_PROFILE.CREATE_PROFILE.TITLE' | translate }}
  </h2>

  <form [formGroup]="createForm">

    <!-- Estructura dinámica basada en isMobile -->
    <div *ngIf="!isMobile" class="flex-col gap-4">
      <!-- Campos para pantallas más grandes (dos columnas) -->

      <div class="grid grid-cols-2 gap-4">
        <!-- Nombre -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}
          </mat-label>
          <input formControlName="name"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}" />
        </mat-form-field>

        <!-- Apellido -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}
          </mat-label>
          <input formControlName="middle_name"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}" />
        </mat-form-field>

        <!-- Dirección -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ADDRESS' | translate }}
          </mat-label>
          <input formControlName="custom:address"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ADDRESS' | translate }}" />
        </mat-form-field>

        <!-- Ciudad -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.CITY' | translate }}
          </mat-label>
          <input formControlName="custom:ciudad"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.CITY' | translate }}" />
        </mat-form-field>

        <!-- Provincia -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PROVINCE' | translate }}
          </mat-label>
          <input formControlName="custom:provincia"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PROVINCE' | translate }}" />
        </mat-form-field>

        <!-- Código Postal -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}
          </mat-label>
          <input formControlName="custom:postcode"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}" />
        </mat-form-field>

        <!-- País -->
        <!-- <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}
          </mat-label>
          <input formControlName="custom:country"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}" />
        </mat-form-field> -->


        <mat-form-field appearance="fill" *ngIf="countriesNames$ | async as countriesNames">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}
          </mat-label>
          <mat-select
            formControlName="custom:country"
            [(value)]="selectedCountry"
            #countrySelect
          >
            <mat-option>
              <input
                matInput
                type="text"
                placeholder="Search country"
                [(ngModel)]="countryFilter"
                [ngModelOptions]="{ standalone: true }"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              />
            </mat-option>

            <mat-option
              *ngFor="let country of filteredCountries(countries, countriesNames, countryFilter)"
              [value]="country"
            >
              <span style="display: inline-flex; align-items: center;">
                <img
                  [src]="country | tuiFlag"
                  width="20"
                  height="14"
                  style="margin-right: 8px;"
                />
                {{ countriesNames[country] }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- ID -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ID' | translate }}
          </mat-label>
          <input formControlName="custom:passport"
                 type="text"
                 matInput
                 placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ID' | translate }}" />
        </mat-form-field>

        <!-- Correo Electrónico -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.EMAIL' | translate }}
          </mat-label>
          <input type="email"
                 formControlName="email"
                 matInput
                 placeholder="example@example.com" />
        </mat-form-field>

        <!-- Teléfono -->
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PHONE' | translate }}
          </mat-label>
          <input type="tel"
                 formControlName="phone_number"
                 matInput
                 placeholder="+34555555123" />
        </mat-form-field>

        <!-- Método de liquidación de comisiones -->
    <!--    <mat-form-field appearance="fill">-->
    <!--      <mat-label>-->
    <!--        {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COMMISSION_PAYMENT_TYPE' | translate }}-->
    <!--      </mat-label>-->
    <!--      <mat-select-->
    <!--        formControlName="commissionPaymentType"-->
    <!--        [(value)]="commissionPaymentType"-->
    <!--      >-->
    <!--        <mat-option-->
    <!--          *ngFor="let method of Object.keys(paymentTypes)"-->
    <!--          [value]="method"-->
    <!--        >-->
    <!--          <span style="display: inline-flex; align-items: center;">-->
    <!--            {{ paymentTypes[method] }}-->
    <!--          </span>-->
    <!--        </mat-option>-->
    <!--      </mat-select>-->
    <!--    </mat-form-field>-->

        <!-- ID de partner al que se asocia -->
        <mat-form-field class="w-full">
          <mat-label>
            Código de referido (código del partner al que se asocia al usuario)
          </mat-label>
          <input type="text"
                 formControlName="custom:Partnercode"
                 matInput />
        </mat-form-field>
      </div>

      <!-- Estado del usuario -->
      <div class="check-full-width flex-col gap-4 m-top">
        <mat-divider></mat-divider>

        <h3 class="m-top">
          Estado del usuario
        </h3>

        <div class="check-full-width flex-col gap-4">
          <div class="check-full-width mb-2">
            <mat-label for="isEnabled">
              <input type="checkbox" id="isEnabled" name="isEnabled" formControlName="isEnabled">
              Habilitado
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="isPhoneVerified">
              <input type="checkbox" id="isPhoneVerified" name="isPhoneVerified" formControlName="isPhoneVerified">
              Nº de teléfono validado
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="isBanned">
              <input type="checkbox" id="isBanned" name="isBanned" formControlName="isBanned">
              Baneado (bloquea el acceso a llamadas internacionales)
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="shouldBeDeleted">
              <input type="checkbox" id="shouldBeDeleted" name="shouldBeDeleted" formControlName="shouldBeDeleted">
              Eliminado (guardar los cambios con esta acción marcada eliminará el usuario de Cognito)
            </mat-label>
          </div>
        </div>
      </div>

        <!-- Acceso a portales -->
      <div class="check-full-width flex-col gap-4 m-top">
        <mat-divider></mat-divider>

        <h3 class="m-top">
          Configuración de acceso
        </h3>
        <div class="check-full-width flex-col gap-4">
          <div class="check-full-width mb-2">
            <mat-label for="isSuperAdmin">
              <input type="checkbox" id="isSuperAdmin" name="isSuperAdmin" formControlName="isSuperAdmin">
              Super Admin
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="accessClients">
              <input type="checkbox" id="accessClients" name="accessClients" formControlName="accessClients">
              Acceso a portal de clientes
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="accessBTB">
              <input type="checkbox" id="accessBTB" name="accessBTB" formControlName="accessBTB">
              Acceso a portal BTB
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="accessBO">
              <input type="checkbox" id="accessBO" name="accessBO" formControlName="accessBO">
              Acceso a portal BackOffice
            </mat-label>
          </div>
        </div>
      </div>

      <!-- Datos BTB -->
      <div class="check-full-width flex-col gap-4 m-top m-bottom" *ngIf="createForm.get('accessBTB')?.value">
        <h3 class="m-top">
          Datos de partner BTB
        </h3>

        <div class="grid grid-cols-2 gap-4">
          <!-- PartnerID -->
          <mat-form-field class="w-full">
            <mat-label>
              Partner ID
            </mat-label>
            <input type="tel"
                   formControlName="custom:btbPartnerId"
                   matInput />
          </mat-form-field>

          <!-- Cuenta bancaria -->
          <mat-form-field class="w-full">
            <mat-label>
              {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.BANK_ACCOUNT' | translate }}
            </mat-label>
            <input formControlName="btbBankAccount"
                   type="text"
                   matInput
                   placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.BANK_ACCOUNT' | translate }}" />
          </mat-form-field>
        </div>
      </div>

      <!-- Roles backoffice -->
      <div class="check-full-width flex-col gap-4 m-top m-bottom" *ngIf="createForm.get('accessBO')?.value">
        <h3 class="m-top">
          Perfiles de administración en BackOffice
        </h3>
        <div class="check-full-width flex-col gap-4">
          <div class="check-full-width mb-2">
            <mat-label for="isAdminUser">
              <input type="checkbox" id="isAdminUser" name="isAdminUser" formControlName="isAdminUser">
              Usuarios
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="isAdminPromotion">
              <input type="checkbox" id="isAdminPromotion" name="isAdminPromotion" formControlName="isAdminPromotion">
              Promociones
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="isAdminTransactions">
              <input type="checkbox" id="isAdminTransactions" name="isAdminTransactions" formControlName="isAdminTransactions">
              Transacciones
            </mat-label>
          </div>

          <div class="check-full-width mb-2">
            <mat-label for="isAdminLogErrors">
              <input type="checkbox" id="isAdminLogErrors" name="isAdminLogErrors" formControlName="isAdminLogErrors">
              Log de errores
            </mat-label>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="isMobile" class="flex flex-col gap-4">
      <!-- Campos para pantallas pequeñas (una columna) -->

      <mat-form-field class="w-full" *ngFor="let field of [
        { label: 'NAME', control: 'name' },
        { label: 'SURNAME', control: 'middle_name' },
        { label: 'ADDRESS', control: 'custom:address' },
        { label: 'CITY', control: 'custom:ciudad' },
        { label: 'PROVINCE', control: 'custom:provincia' },
        { label: 'ZIPCODE', control: 'custom:postcode' },
        { label: 'COUNTRY', control: 'custom:country' },
        { label: 'ID', control: 'custom:passport' },
        { label: 'EMAIL', control: 'email' },
        { label: 'PHONE', control: 'phone_number' },
        { label: 'BANK_ACCOUNT', control: 'bankAccount' }
      ]">
        <mat-label>
          {{ ('COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.' + field.label) | translate }}
        </mat-label>
        <input [formControlName]="field.control" matInput />
      </mat-form-field>

    </div>

     <!-- Botones -->
    <div class="flex justify-between gap-4 mt-12">
      <app-button expand="full" color="secondary" (click)="goBack()">
        {{ 'COMMON.CANCEL' | translate }}
      </app-button>
      <app-button expand="full" (click)="onUpdate()">
        {{ 'COMMON.CONFIRM' | translate }}
      </app-button>
    </div>

  </form>
</div>

<style>
  .grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.gap-4 {
  gap: 16px;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.w-full {
  width: 100%;
}

.m-top {
  margin-top: 24px;
}

.m-bottom {
  margin-bottom: 24px;
}
</style>
